import _import from './lazy-importer';
import NavigatorInternal from '@/views/navigator/NavigatorInternal';
import JdbcRoutes from './routes/jdbc';
import MongodbRoutes from './routes/mongodb';
import RedisRoutes from './routes/redis';

/**
 * 路由详解
 * name: 对于导航栏路由是必须的，即使该路由不对应到组件
 * meta.inNav: 判断是否为一个导航栏路由
 * meta.title: 对于导航栏路由是必须的
 * meta.action: 仅适用于导航栏路由，设置此属性后可以不对应到某个组件
 * meta.notAsRoot: 仅适用于导航栏路由，默认情况下如果导航栏的 children 只有一项，则会自动将下面的一项渲染在顶级
 *              设置此属性为 true 将会保持渲染为级联结构
 */
export default [
  // 预留的首页路由。目前该路由仅用作跳板页，未来如果有 DMS 的展示页，可以启用此路由
  {
    path: '/',
    name: 'Index',
    redirect: { name: 'Navigator' }
  },
  // 导航页
  {
    path: '/navigator',
    name: 'Navigator',
    component: NavigatorInternal,
    meta: { title: '选择数据库' }
  },
  //登录页
  {
    path: '/login',
    name: 'Login',
    component: _import('navigator/Login'),
    meta: { title: '登录' }
  },
  // 404 页面
  {
    path: '/404',
    name: 'Error404',
    component: _import('errors/404'),
    meta: { title: '404' }
  },
  // 创建订单页
  // {
  //   path: '/order/create',
  //   name: 'Order',
  //   component: _import('order/Index'),
  //   meta: { title: '创建订单' }
  // },
  // 数据库相关路由
  ...JdbcRoutes,
  ...MongodbRoutes,
  ...RedisRoutes,
  // 最后添加 404 路由
  { path: '*', redirect: '/404' }
];
